(() => {
  'use strict';

  const dpsReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const dpsEscape = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  const dpsMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount); }
    catch (error) { return `$${amount.toFixed(2)} AUD`; }
  };

  dpsReady(() => {
    const dpsToggle = document.querySelector('[data-dps-mega-toggle]');
    const dpsMega = document.querySelector('[data-dps-mega-menu]');

    if (dpsToggle && dpsMega) {
      dpsToggle.addEventListener('click', () => {
        const dpsExpanded = dpsToggle.getAttribute('aria-expanded') === 'true';
        dpsToggle.setAttribute('aria-expanded', String(!dpsExpanded));
        dpsMega.hidden = dpsExpanded;
      });

      document.addEventListener('click', (event) => {
        if (dpsMega.hidden) return;
        if (!dpsMega.contains(event.target) && !dpsToggle.contains(event.target)) {
          dpsMega.hidden = true;
          dpsToggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !dpsMega.hidden) {
          dpsMega.hidden = true;
          dpsToggle.setAttribute('aria-expanded', 'false');
          dpsToggle.focus();
        }
      });
    }


    const dpsMobileToggle = document.querySelector('[data-dps-mobile-menu-toggle]');
    const dpsMobileMenu = document.querySelector('[data-dps-mobile-menu]');
    const dpsHeaderTop = document.querySelector('.dps-header__top');
    const dpsMobileDrilldown = document.querySelector('[data-dps-mobile-drilldown]');
    const dpsMobileTrack = document.querySelector('[data-dps-mobile-menu-track]');

    const dpsSetMobileMenuTop = () => {
      if (!dpsHeaderTop) return;
      const rect = dpsHeaderTop.getBoundingClientRect();
      document.documentElement.style.setProperty('--dps-mobile-menu-top', `${Math.max(0, Math.round(rect.bottom))}px`);
    };

    const dpsResetMobileDrilldown = () => {
      if (!dpsMobileDrilldown) return;
      dpsMobileDrilldown.setAttribute('data-dps-view', 'root');
      dpsMobileDrilldown.querySelectorAll('[data-dps-mobile-menu-view="child"]').forEach((view) => {
        view.hidden = true;
      });
      if (dpsMobileTrack) dpsMobileTrack.style.transform = '';
    };

    const dpsCloseMobileMenu = () => {
      if (!dpsMobileToggle || !dpsMobileMenu) return;
      dpsMobileToggle.setAttribute('aria-expanded', 'false');
      dpsMobileMenu.classList.remove('dps-header__nav--open');
      document.documentElement.classList.remove('dps-mobile-menu-open');
      dpsResetMobileDrilldown();
    };

    const dpsOpenMobileMenu = () => {
      if (!dpsMobileToggle || !dpsMobileMenu) return;
      dpsSetMobileMenuTop();
      dpsResetMobileDrilldown();
      dpsMobileToggle.setAttribute('aria-expanded', 'true');
      dpsMobileMenu.classList.add('dps-header__nav--open');
      document.documentElement.classList.add('dps-mobile-menu-open');
    };

    if (dpsMobileToggle && dpsMobileMenu) {
      dpsSetMobileMenuTop();
      window.addEventListener('resize', dpsSetMobileMenuTop, { passive: true });
      window.addEventListener('scroll', dpsSetMobileMenuTop, { passive: true });

      dpsMobileToggle.addEventListener('click', () => {
        if (dpsMobileMenu.classList.contains('dps-header__nav--open')) dpsCloseMobileMenu();
        else dpsOpenMobileMenu();
      });

      dpsMobileMenu.addEventListener('click', (event) => {
        if (event.target === dpsMobileMenu) dpsCloseMobileMenu();

        const closeButton = event.target.closest('[data-dps-mobile-menu-close]');
        if (closeButton) {
          event.preventDefault();
          dpsCloseMobileMenu();
          return;
        }

        const nextButton = event.target.closest('[data-dps-mobile-submenu-open]');
        if (nextButton && dpsMobileDrilldown) {
          event.preventDefault();
          const targetId = nextButton.getAttribute('data-dps-mobile-submenu-open');
          const targetPanel = targetId ? document.getElementById(targetId) : null;
          if (!targetPanel) return;
          dpsMobileDrilldown.querySelectorAll('[data-dps-mobile-menu-view="child"]').forEach((view) => {
            view.hidden = view !== targetPanel;
          });
          targetPanel.hidden = false;
          dpsMobileDrilldown.setAttribute('data-dps-view', 'child');
          targetPanel.scrollTop = 0;
          return;
        }

        const backButton = event.target.closest('[data-dps-mobile-submenu-back]');
        if (backButton && dpsMobileDrilldown) {
          event.preventDefault();
          dpsResetMobileDrilldown();
          return;
        }

        if (event.target.closest('a')) dpsCloseMobileMenu();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && dpsMobileMenu.classList.contains('dps-header__nav--open')) {
          dpsCloseMobileMenu();
          dpsMobileToggle.focus();
        }
      });
    }

    document.addEventListener('click', (event) => {
      const dpsButton = event.target.closest('.dps-quantity__button');
      if (!dpsButton) return;

      const dpsQuantity = dpsButton.closest('.dps-quantity');
      const dpsInput = dpsQuantity ? dpsQuantity.querySelector('.dps-quantity__input') : null;
      if (!dpsInput) return;

      event.preventDefault();
      const dpsMin = parseInt(dpsInput.getAttribute('min') || '1', 10);
      const dpsMaxAttr = dpsInput.getAttribute('max');
      const dpsMax = dpsMaxAttr ? parseInt(dpsMaxAttr, 10) : null;
      const dpsCurrent = parseInt(dpsInput.value || String(dpsMin), 10) || dpsMin;
      let dpsNext = dpsButton.name === 'plus' ? dpsCurrent + 1 : dpsCurrent - 1;
      dpsNext = Math.max(dpsMin, dpsNext);
      if (dpsMax !== null && !Number.isNaN(dpsMax)) dpsNext = Math.min(dpsMax, dpsNext);

      dpsInput.value = String(dpsNext);
      dpsInput.dispatchEvent(new Event('input', { bubbles: true }));
      dpsInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelectorAll('[data-dps-product-gallery]').forEach((gallery) => {
      const dpsMainMedia = gallery.querySelector('[data-dps-main-media]');
      const dpsSlidesTrack = gallery.querySelector('[data-dps-slides]');
      const dpsSlides = dpsSlidesTrack ? Array.from(dpsSlidesTrack.querySelectorAll('[data-dps-slide-index]')) : [];
      const dpsSlider = gallery.querySelector('[data-dps-thumb-slider]');
      const dpsThumbsTrack = gallery.querySelector('[data-dps-thumb-track]');
      const dpsThumbs = Array.from(gallery.querySelectorAll('[data-dps-thumb]'));
      const dpsPrev = gallery.querySelector('[data-dps-thumb-prev]');
      const dpsNext = gallery.querySelector('[data-dps-thumb-next]');
      const dpsSlideCount = dpsSlides.length || dpsThumbs.length;
      let dpsActiveIndex = Math.max(0, dpsThumbs.findIndex((thumb) => thumb.classList.contains('dps-product__thumb--active')));
      if (dpsActiveIndex < 0) dpsActiveIndex = 0;

      // Reflect active slide in CSS by translating the track. All math is numeric;
      // no user-controlled string ever reaches a CSS property value.
      const dpsApplyTrackOffset = (px) => {
        if (!dpsSlidesTrack) return;
        if (px === null || px === undefined) {
          // Reset to the snapped position for the active index (percentage).
          dpsSlidesTrack.style.transform = `translate3d(-${Number(dpsActiveIndex) * 100}%, 0, 0)`;
        } else {
          // During a drag — pixel-precise translation relative to the snapped position.
          const snappedPct = Number(dpsActiveIndex) * 100;
          dpsSlidesTrack.style.transform = `translate3d(calc(-${snappedPct}% + ${Number(px)}px), 0, 0)`;
        }
      };

      const dpsUpdateThumbButtons = () => {
        if (!dpsPrev || !dpsNext) return;
        dpsPrev.disabled = dpsSlideCount <= 1 || dpsActiveIndex <= 0;
        dpsNext.disabled = dpsSlideCount <= 1 || dpsActiveIndex >= dpsSlideCount - 1;
      };

      const dpsGoToIndex = (rawIndex, shouldScrollThumb = true) => {
        if (dpsSlideCount === 0) return;
        const index = Math.max(0, Math.min(dpsSlideCount - 1, Number(rawIndex) || 0));
        dpsActiveIndex = index;
        dpsApplyTrackOffset(null);
        dpsThumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('dps-product__thumb--active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        const target = dpsThumbs[index];
        if (target && shouldScrollThumb) {
          target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
        dpsUpdateThumbButtons();
      };

      dpsThumbs.forEach((dpsThumb, i) => {
        dpsThumb.addEventListener('click', () => dpsGoToIndex(i));
      });

      if (dpsPrev) {
        dpsPrev.addEventListener('click', () => dpsGoToIndex(dpsActiveIndex - 1));
      }

      if (dpsNext) {
        dpsNext.addEventListener('click', () => dpsGoToIndex(dpsActiveIndex + 1));
      }

      if (dpsThumbsTrack) {
        dpsThumbsTrack.addEventListener('keydown', (event) => {
          if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
          dpsGoToIndex(dpsActiveIndex + direction);
        });
      }

      // Touch-swipe gallery navigation. Listeners are passive so the browser can keep
      // scrolling smooth; horizontal drag is reserved for us via touch-action: pan-y in CSS.
      // Numeric values from event.touches are coerced through Number() before any math
      // so a malformed event payload cannot influence DOM behaviour.
      if (dpsMainMedia && dpsSlideCount > 1) {
        const dpsSwipeThreshold = 40; // px before we commit to a slide change
        let dpsSwipeStartX = null;
        let dpsSwipeStartY = null;
        let dpsSwipeActive = false;
        let dpsSwipeAxisLocked = false;
        let dpsSwipeIsHorizontal = false;

        dpsMainMedia.addEventListener('touchstart', (event) => {
          if (!event.touches || event.touches.length !== 1) return;
          const touch = event.touches[0];
          dpsSwipeStartX = Number(touch.clientX);
          dpsSwipeStartY = Number(touch.clientY);
          dpsSwipeActive = true;
          dpsSwipeAxisLocked = false;
          dpsSwipeIsHorizontal = false;
        }, { passive: true });

        dpsMainMedia.addEventListener('touchmove', (event) => {
          if (!dpsSwipeActive || !event.touches || event.touches.length !== 1) return;
          const touch = event.touches[0];
          const dx = Number(touch.clientX) - dpsSwipeStartX;
          const dy = Number(touch.clientY) - dpsSwipeStartY;
          if (!dpsSwipeAxisLocked) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            dpsSwipeIsHorizontal = Math.abs(dx) > Math.abs(dy);
            dpsSwipeAxisLocked = true;
            if (!dpsSwipeIsHorizontal) {
              dpsSwipeActive = false;
              dpsMainMedia.classList.remove('dps-product__main-media--swiping');
              dpsApplyTrackOffset(null);
              return;
            }
          }
          if (!dpsSwipeIsHorizontal) return;
          dpsMainMedia.classList.add('dps-product__main-media--swiping');
          // Apply rubber-banding at the edges so it feels natural when there is no next/prev slide.
          let drag = dx;
          if ((dpsActiveIndex === 0 && drag > 0) ||
              (dpsActiveIndex === dpsSlideCount - 1 && drag < 0)) {
            drag = drag * 0.35;
          }
          const wrapperWidth = dpsMainMedia.clientWidth || 1;
          const clamped = Math.max(-wrapperWidth, Math.min(wrapperWidth, drag));
          dpsApplyTrackOffset(clamped);
        }, { passive: true });

        const dpsResetSwipe = () => {
          dpsSwipeActive = false;
          dpsSwipeStartX = null;
          dpsSwipeStartY = null;
          dpsSwipeAxisLocked = false;
          dpsSwipeIsHorizontal = false;
          dpsMainMedia.classList.remove('dps-product__main-media--swiping');
          dpsApplyTrackOffset(null);
        };

        dpsMainMedia.addEventListener('touchend', (event) => {
          if (!dpsSwipeActive) { dpsResetSwipe(); return; }
          if (!dpsSwipeIsHorizontal) { dpsResetSwipe(); return; }
          const touch = (event.changedTouches && event.changedTouches[0]) || null;
          if (!touch) { dpsResetSwipe(); return; }
          const dx = Number(touch.clientX) - dpsSwipeStartX;
          dpsMainMedia.classList.remove('dps-product__main-media--swiping');
          if (Math.abs(dx) >= dpsSwipeThreshold) {
            if (dx < 0) {
              dpsGoToIndex(dpsActiveIndex + 1, false);
            } else {
              dpsGoToIndex(dpsActiveIndex - 1, false);
            }
          } else {
            dpsApplyTrackOffset(null);
          }
          dpsSwipeActive = false;
          dpsSwipeStartX = null;
          dpsSwipeStartY = null;
          dpsSwipeAxisLocked = false;
          dpsSwipeIsHorizontal = false;
        }, { passive: true });

        dpsMainMedia.addEventListener('touchcancel', dpsResetSwipe, { passive: true });
      }

      // Mouse drag (desktop). Mirrors the touch behaviour so laptops without a
      // touchscreen can drag between slides too. We listen on the wrapper for
      // mousedown only, then attach move/up to document so the drag continues
      // even if the cursor leaves the wrapper. All deltas pass through Number().
      if (dpsMainMedia && dpsSlideCount > 1) {
        const dpsMouseThreshold = 40; // px before we commit
        let dpsMouseStartX = null;
        let dpsMouseDragging = false;
        let dpsMouseMoved = false;

        const dpsMouseMove = (event) => {
          if (!dpsMouseDragging) return;
          const dx = Number(event.clientX) - dpsMouseStartX;
          if (Math.abs(dx) > 4) dpsMouseMoved = true;
          if (!dpsMouseMoved) return;
          dpsMainMedia.classList.add('dps-product__main-media--swiping');
          let drag = dx;
          if ((dpsActiveIndex === 0 && drag > 0) ||
              (dpsActiveIndex === dpsSlideCount - 1 && drag < 0)) {
            drag = drag * 0.35;
          }
          const wrapperWidth = dpsMainMedia.clientWidth || 1;
          const clamped = Math.max(-wrapperWidth, Math.min(wrapperWidth, drag));
          dpsApplyTrackOffset(clamped);
        };

        const dpsMouseUp = (event) => {
          if (!dpsMouseDragging) return;
          const dx = Number(event.clientX) - dpsMouseStartX;
          dpsMouseDragging = false;
          dpsMainMedia.classList.remove('dps-product__main-media--swiping');
          document.removeEventListener('mousemove', dpsMouseMove);
          document.removeEventListener('mouseup', dpsMouseUp);
          if (dpsMouseMoved && Math.abs(dx) >= dpsMouseThreshold) {
            if (dx < 0) {
              dpsGoToIndex(dpsActiveIndex + 1, false);
            } else {
              dpsGoToIndex(dpsActiveIndex - 1, false);
            }
          } else {
            dpsApplyTrackOffset(null);
          }
          dpsMouseStartX = null;
          dpsMouseMoved = false;
        };

        dpsMainMedia.addEventListener('mousedown', (event) => {
          // Primary button only. Don't hijack drags that started on a button or link.
          if (event.button !== 0) return;
          if (event.target && event.target.closest && event.target.closest('a, button, input, select, textarea')) return;
          dpsMouseStartX = Number(event.clientX);
          dpsMouseDragging = true;
          dpsMouseMoved = false;
          // Stop the browser's native image-drag from firing.
          event.preventDefault();
          document.addEventListener('mousemove', dpsMouseMove);
          document.addEventListener('mouseup', dpsMouseUp);
        });

        // Block the click that browsers fire after a mouse drag, otherwise a
        // drag-released-over-the-image triggers an accidental link/button click.
        dpsMainMedia.addEventListener('click', (event) => {
          if (dpsMouseMoved) {
            event.preventDefault();
            event.stopPropagation();
            dpsMouseMoved = false;
          }
        }, true);
      }

      // Hint to the user that the gallery is draggable on desktop.
      if (dpsMainMedia && dpsSlideCount > 1) {
        dpsMainMedia.classList.add('dps-product__main-media--draggable');
      }

      // Auto-hide the thumb prev/next buttons when the thumb strip fits in its container.
      // Uses ResizeObserver where available; falls back to a window resize listener.
      if (dpsSlider && dpsThumbsTrack && dpsSlideCount > 1) {
        const dpsUpdateThumbOverflow = () => {
          // overflow check works for both vertical (desktop) and horizontal (mobile) strips.
          const overflowsX = dpsThumbsTrack.scrollWidth - dpsThumbsTrack.clientWidth > 1;
          const overflowsY = dpsThumbsTrack.scrollHeight - dpsThumbsTrack.clientHeight > 1;
          const overflows = overflowsX || overflowsY;
          dpsSlider.setAttribute('data-dps-thumbs-overflow', overflows ? 'true' : 'false');
        };
        dpsUpdateThumbOverflow();
        if (typeof ResizeObserver === 'function') {
          const dpsThumbObserver = new ResizeObserver(dpsUpdateThumbOverflow);
          dpsThumbObserver.observe(dpsThumbsTrack);
          dpsThumbObserver.observe(dpsSlider);
        } else {
          window.addEventListener('resize', dpsUpdateThumbOverflow, { passive: true });
        }
        // Re-check after images have loaded (their height affects strip overflow).
        gallery.querySelectorAll('.dps-product__thumb-image').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', dpsUpdateThumbOverflow, { once: true });
          img.addEventListener('error', dpsUpdateThumbOverflow, { once: true });
        });
      } else if (dpsSlider) {
        dpsSlider.setAttribute('data-dps-thumbs-overflow', 'false');
      }

      // Initial paint — set the track to the active index without animation.
      if (dpsSlidesTrack) {
        dpsSlidesTrack.style.transition = 'none';
        dpsApplyTrackOffset(null);
        // Force a reflow so the next assignment animates.
        // eslint-disable-next-line no-unused-expressions
        dpsSlidesTrack.offsetHeight;
        dpsSlidesTrack.style.transition = '';
      }

      dpsUpdateThumbButtons();
    });

    const dpsCartCount = document.querySelector('[data-dps-cart-count]');
    const dpsCartMenu = document.querySelector('[data-dps-cart-menu]');
    const dpsCartMenuToggle = document.querySelector('[data-dps-cart-toggle]');
    const dpsCartMenuBody = document.querySelector('[data-dps-cart-menu-body]');
    const dpsCartMenuTotal = document.querySelector('[data-dps-cart-menu-total]');
    const dpsCartDrawer = document.querySelector('[data-dps-cart-drawer]');
    const dpsCartDrawerBody = document.querySelector('[data-dps-cart-drawer-body]');
    const dpsCartDrawerTotal = document.querySelector('[data-dps-cart-drawer-total]');

    const dpsRenderCartItems = (cart, mode = 'menu') => {
      if (!cart || !cart.items || cart.items.length === 0) return '<p class="dps-cart-menu__empty">Your cart is empty.</p>';
      const limit = mode === 'drawer' ? 8 : 4;
      return cart.items.slice(0, limit).map((item) => {
        const safeUrl = dpsEscape(item.url);
        const safeTitle = dpsEscape(item.product_title);
        const safeImage = item.image ? dpsEscape(item.image) : '';
        const safeQty = Number(item.quantity) || 0;
        const wrap = mode === 'drawer' ? 'dps-cart-drawer' : 'dps-cart-menu';
        const image = safeImage ? `<img class="${wrap}__image" src="${safeImage}" alt="${safeTitle}" loading="lazy">` : '';
        return `<div class="${wrap}__item"><a class="${wrap}__media" href="${safeUrl}">${image}</a><div class="${wrap}__copy"><a class="${wrap}__product" href="${safeUrl}">${safeTitle}</a><span class="${wrap}__meta">Qty ${safeQty} · ${dpsMoney(item.final_line_price)}</span></div></div>`;
      }).join('');
    };

    const dpsRefreshCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart fetch failed');
      const cart = await response.json();
      if (dpsCartCount) dpsCartCount.textContent = String(cart.item_count || 0);
      if (dpsCartMenuBody) dpsCartMenuBody.innerHTML = dpsRenderCartItems(cart, 'menu');
      if (dpsCartMenuTotal) dpsCartMenuTotal.textContent = dpsMoney(cart.total_price);
      if (dpsCartDrawerBody) dpsCartDrawerBody.innerHTML = dpsRenderCartItems(cart, 'drawer');
      if (dpsCartDrawerTotal) dpsCartDrawerTotal.textContent = dpsMoney(cart.total_price);
      return cart;
    };

    const dpsOpenCartMenu = async () => {
      if (!dpsCartMenu || !dpsCartMenuToggle) return;
      try { await dpsRefreshCart(); } catch (error) { /* no-op */ }
      dpsCartMenu.hidden = false;
      dpsCartMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const dpsCloseCartMenu = () => {
      if (!dpsCartMenu || !dpsCartMenuToggle) return;
      dpsCartMenu.hidden = true;
      dpsCartMenuToggle.setAttribute('aria-expanded', 'false');
    };

    const dpsOpenCartDrawer = async () => {
      if (!dpsCartDrawer) return;
      try { await dpsRefreshCart(); } catch (error) { /* no-op */ }
      dpsCartDrawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dps-cart-open');
    };

    const dpsCloseCartDrawer = () => {
      if (!dpsCartDrawer) return;
      dpsCartDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dps-cart-open');
    };

    if (dpsCartMenuToggle) {
      dpsCartMenuToggle.addEventListener('click', async () => {
        if (!dpsCartMenu || dpsCartMenu.hidden) await dpsOpenCartMenu();
        else dpsCloseCartMenu();
      });
    }

    document.querySelectorAll('[data-dps-cart-close]').forEach((button) => button.addEventListener('click', dpsCloseCartDrawer));

    document.addEventListener('click', (event) => {
      if (!dpsCartMenu || dpsCartMenu.hidden) return;
      const wrap = document.querySelector('[data-dps-cart-menu-wrap]');
      if (wrap && !wrap.contains(event.target)) dpsCloseCartMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        dpsCloseCartMenu();
        dpsCloseCartDrawer();
        if (typeof dpsCloseMobileMenu === 'function') dpsCloseMobileMenu();
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        if (submitter && submitter.hasAttribute('data-dps-buy-now')) return;
        event.preventDefault();
        const button = submitter || form.querySelector('[type="submit"]');
        if (button) {
          button.disabled = true;
          button.dataset.dpsOriginalText = button.textContent;
          button.textContent = 'Adding...';
        }
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart add failed');
          await dpsOpenCartDrawer();
        } catch (error) {
          form.submit();
        } finally {
          if (button) {
            button.disabled = false;
            button.textContent = button.dataset.dpsOriginalText || 'Add to Cart';
          }
        }
      });
    });

    document.querySelectorAll('[data-dps-buy-now]').forEach((dpsButton) => {
      dpsButton.addEventListener('click', async (event) => {
        const dpsForm = dpsButton.closest('form');
        if (!dpsForm) return;
        event.preventDefault();
        dpsButton.disabled = true;
        try {
          const dpsResponse = await fetch('/cart/add.js', { method: 'POST', body: new FormData(dpsForm), headers: { Accept: 'application/json' } });
          if (!dpsResponse.ok) throw new Error('Cart add failed');
          window.location.href = '/checkout';
        } catch (dpsError) {
          dpsForm.submit();
        }
      });
    });

    // Sticky add-to-cart bar on the product page. Appears when the inline action
    // buttons leave the viewport, hides when they come back. The sticky buttons
    // proxy clicks to the original form buttons so all existing handlers
    // (cart add, buy-now, drawer open) are reused — no duplicated network code.
    const dpsStickyBar = document.querySelector('[data-dps-sticky-bar]');
    const dpsProductActions = document.querySelector('[data-dps-product-actions]');
    if (dpsStickyBar && dpsProductActions) {
      const dpsProductForm = dpsProductActions.closest('form');
      const dpsInlineAdd = dpsProductForm ? dpsProductForm.querySelector('.dps-product__cart-button') : null;
      const dpsInlineBuy = dpsProductForm ? dpsProductForm.querySelector('[data-dps-buy-now]') : null;
      const dpsStickyAdd = dpsStickyBar.querySelector('[data-dps-sticky-add]');
      const dpsStickyBuy = dpsStickyBar.querySelector('[data-dps-sticky-buy]');

      const dpsShowSticky = () => {
        dpsStickyBar.removeAttribute('hidden');
        dpsStickyBar.setAttribute('aria-hidden', 'false');
        // Wait one frame so the slide-up transition runs from the hidden position.
        requestAnimationFrame(() => {
          dpsStickyBar.classList.add('dps-product__sticky-bar--visible');
        });
      };

      const dpsHideSticky = () => {
        dpsStickyBar.classList.remove('dps-product__sticky-bar--visible');
        dpsStickyBar.setAttribute('aria-hidden', 'true');
        // Wait for the slide-down transition before applying `hidden`, so it animates.
        const onTransitionEnd = (event) => {
          if (event.target !== dpsStickyBar) return;
          if (!dpsStickyBar.classList.contains('dps-product__sticky-bar--visible')) {
            dpsStickyBar.setAttribute('hidden', '');
          }
          dpsStickyBar.removeEventListener('transitionend', onTransitionEnd);
        };
        dpsStickyBar.addEventListener('transitionend', onTransitionEnd);
      };

      if (typeof IntersectionObserver === 'function') {
        const dpsStickyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              dpsHideSticky();
            } else {
              // Only show after the user has actually scrolled past the buttons,
              // not when the page first loads with the buttons below the fold.
              const rect = entry.boundingClientRect;
              if (rect.bottom < 0) dpsShowSticky();
              else dpsHideSticky();
            }
          });
        }, { threshold: [0, 0.1] });
        dpsStickyObserver.observe(dpsProductActions);
      }

      // Forward clicks to the original buttons (which carry the real handlers).
      if (dpsStickyAdd && dpsInlineAdd) {
        dpsStickyAdd.addEventListener('click', () => {
          dpsInlineAdd.click();
        });
      }
      if (dpsStickyBuy && dpsInlineBuy) {
        dpsStickyBuy.addEventListener('click', () => {
          dpsInlineBuy.click();
        });
      }
    }

    const searchWrap = document.querySelector('[data-dps-search-wrap]');
    const searchInput = document.querySelector('[data-dps-search-input]');
    const suggestBox = document.querySelector('[data-dps-search-suggest]');
    let suggestTimer;
    let suggestController;

    const showSuggest = (html) => {
      if (!suggestBox) return;
      suggestBox.innerHTML = html;
      suggestBox.hidden = false;
    };

    const hideSuggest = () => { if (suggestBox) suggestBox.hidden = true; };

    const runSuggest = async (query) => {
      if (!query || query.trim().length < 2) {
        showSuggest('<div class="dps-search-suggest__state">Type at least 2 characters.</div>');
        return;
      }
      if (suggestController) suggestController.abort();
      suggestController = new AbortController();
      showSuggest('<div class="dps-search-suggest__state">Searching...</div>');
      const url = `/search/suggest.json?q=${encodeURIComponent(query.trim())}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      try {
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: suggestController.signal });
        if (!response.ok) throw new Error('Suggest failed');
        const data = await response.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          showSuggest(`<div class="dps-search-suggest__state">No products found for “${dpsEscape(query)}”.</div>`);
          return;
        }
        const rows = products.map((product) => {
          const image = product.image ? `<img class="dps-search-suggest__image" src="${dpsEscape(product.image)}" alt="${dpsEscape(product.title)}" loading="lazy">` : '<span class="dps-search-suggest__image dps-search-suggest__image--empty"></span>';
          return `<a class="dps-search-suggest__item" href="${dpsEscape(product.url)}">${image}<span class="dps-search-suggest__copy"><strong class="dps-search-suggest__title">${dpsEscape(product.title)}</strong><span class="dps-search-suggest__price">${dpsEscape(product.price || '')}</span></span></a>`;
        }).join('');
        showSuggest(`${rows}<a class="dps-search-suggest__view" href="/search?q=${encodeURIComponent(query.trim())}&type=product">View all results</a>`);
      } catch (error) {
        if (error.name !== 'AbortError') showSuggest('<div class="dps-search-suggest__state">Search suggestions are unavailable. Press Enter to search.</div>');
      }
    };

    if (searchInput && suggestBox) {
      searchInput.addEventListener('input', () => {
        clearTimeout(suggestTimer);
        suggestTimer = setTimeout(() => runSuggest(searchInput.value), 220);
      });
      searchInput.addEventListener('focus', () => {
        if (searchInput.value.length >= 2) runSuggest(searchInput.value);
      });
      document.addEventListener('click', (event) => {
        if (searchWrap && !searchWrap.contains(event.target)) hideSuggest();
      });
      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') hideSuggest();
      });
    }


    document.querySelectorAll('[data-dps-product-tabs]').forEach((tabs) => {
      const tabButtons = Array.from(tabs.querySelectorAll('[data-dps-product-tab]'));
      const tabPanels = Array.from(tabs.querySelectorAll('[data-dps-product-panel]'));
      const activateTab = (name) => {
        tabButtons.forEach((button) => {
          const active = button.getAttribute('data-dps-product-tab') === name;
          button.classList.toggle('dps-product__tab--active', active);
          button.setAttribute('aria-selected', String(active));
        });
        tabPanels.forEach((panel) => {
          const active = panel.getAttribute('data-dps-product-panel') === name;
          panel.classList.toggle('dps-product__tab-panel--active', active);
          panel.hidden = !active;
        });
      };
      tabButtons.forEach((button) => {
        button.addEventListener('click', () => activateTab(button.getAttribute('data-dps-product-tab')));
      });
      tabs.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const currentIndex = tabButtons.indexOf(document.activeElement);
        if (currentIndex < 0) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + tabButtons.length) % tabButtons.length;
        tabButtons[nextIndex].focus();
        tabButtons[nextIndex].click();
      });
    });



    const dpsMobileFilterMq = window.matchMedia('(max-width: 989px)');
    const dpsSyncMobileFilters = () => {
      document.querySelectorAll('[data-dps-mobile-filter]').forEach((filterDetails) => {
        if (dpsMobileFilterMq.matches) {
          filterDetails.removeAttribute('open');
        } else {
          filterDetails.setAttribute('open', 'open');
        }
      });
    };
    dpsSyncMobileFilters();
    if (typeof dpsMobileFilterMq.addEventListener === 'function') {
      dpsMobileFilterMq.addEventListener('change', dpsSyncMobileFilters);
    } else if (typeof dpsMobileFilterMq.addListener === 'function') {
      dpsMobileFilterMq.addListener(dpsSyncMobileFilters);
    }

    document.querySelectorAll('[data-dps-mobile-filter]').forEach((filterDetails) => {
      filterDetails.addEventListener('toggle', () => {
        if (!dpsMobileFilterMq.matches && !filterDetails.open) {
          filterDetails.setAttribute('open', 'open');
        }
      });
    });

    document.querySelectorAll('[data-dps-filter-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const form = input.closest('form');
        if (form) form.submit();
      });
    });

    // Replaces inline onchange="this.form.submit()" so the theme works under a strict CSP (no inline-script allowance required).
    document.querySelectorAll('[data-dps-sort-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });
  });
})();
